import { useLocation, useNavigate } from "react-router";
import { HiChevronDoubleLeft, HiChevronDoubleRight } from "react-icons/hi";

import { useAllJobsContext } from "@/pages/all-jobs";
import { PageBtnContainerWrapper } from "@/components/wrappers";

const PageBtnContainer = () => {
  const {
    data: { pages, currentPage },
  } = useAllJobsContext();

  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  // const pagination = Array.from({ length: pages }, (_, idx) => ++idx);

  const handlePageChange = (pageNumber: number) => {
    const searchParams = new URLSearchParams(search);
    searchParams.set("page", pageNumber.toString());
    navigate(`${pathname}?${searchParams.toString()}`);
  };

  const addPageButton = ({ pageNumber, activeClass }: { pageNumber: number; activeClass: boolean }) => {
    return (
      <button className={`btn page-btn ${activeClass && "active"}`} key={pageNumber} onClick={() => handlePageChange(pageNumber)}>
        {pageNumber}
      </button>
    );
  };

  const renderPageButtons = () => {
    const pageButtons = [];

    // Add the first page button
    pageButtons.push(addPageButton({ pageNumber: 1, activeClass: currentPage === 1 }));
    // Add the dots before the current page if there are more than 3 pages
    if (currentPage > 3) {
      pageButtons.push(
        <span className="page-btn dots" key="dots-1">
          ....
        </span>,
      );
    }
    // one before current page
    if (currentPage !== 1 && currentPage !== 2) {
      pageButtons.push(addPageButton({ pageNumber: currentPage - 1, activeClass: false }));
    }

    // Add the current page button
    if (currentPage !== 1 && currentPage !== pages) {
      pageButtons.push(addPageButton({ pageNumber: currentPage, activeClass: true }));
    }

    // one after current page
    if (currentPage !== pages && currentPage !== pages - 1) {
      pageButtons.push(addPageButton({ pageNumber: currentPage + 1, activeClass: false }));
    }
    if (currentPage < pages - 2) {
      pageButtons.push(
        <span className=" page-btn dots" key="dots+1">
          ....
        </span>,
      );
    }

    // Add the last page button
    pageButtons.push(
      addPageButton({
        pageNumber: pages,
        activeClass: currentPage === pages,
      }),
    );

    return pageButtons;
  };

  return (
    <PageBtnContainerWrapper>
      <button
        className="btn prev-btn"
        onClick={() => {
          let prevPage = currentPage - 1;
          if (prevPage < 1) prevPage = pages;
          handlePageChange(prevPage);
        }}
      >
        <HiChevronDoubleLeft />
        prev
      </button>
      <div className="btn-container">{renderPageButtons()}</div>
      <button
        className="btn next-btn"
        onClick={() => {
          let nextPage = currentPage + 1;
          if (nextPage > pages) nextPage = 1;
          handlePageChange(nextPage);
        }}
      >
        next <HiChevronDoubleRight />
      </button>
    </PageBtnContainerWrapper>
  );
};

export default PageBtnContainer;
